<template>
  <v-card max-width="600px">
    <v-card-title style="display: flex; justify-content: center">
      <p class="small">{{ mode }}</p>
    </v-card-title>
    <v-card-text
      style="max-height: 80vh; overflow-y: auto; scrollbar-width: unset"
    >
      <v-form
        @submit.prevent="submitForm"
        class="mx-5 my-1"
        ref="form"
        v-model="valid"
      >
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mx-1"
        >
          {{ alertValidate }}</v-alert
        >
        <v-text-field
          name="element"
          v-model="items.element.data"
          :type="items.element.type"
          :label="items.element.label"
          :rules="items.element.rules"
          outlined
          dense
        />
        <div class="d-flex">
          <v-menu
            ref="menuFrom"
            v-model="menuFrom"
            offset-y
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="items.timeFrom"
                name="from"
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                :rules="items.from.rules"
                :label="items.from.label"
                required
                style="width: 50%"
              ></v-text-field>
            </template>
            <v-time-picker
              v-model="items.timeFrom"
              class="mt-4"
              scrollable
              format="24hr"
              :min="minFrom"
              :max="maxFrom"
              @click="$refs.menuFrom.save(items.timeFrom)"
            >
              <v-btn
                text
                color="primary"
                @click="timeFromSave(items.timeFrom)"
                class="v-picker__actions"
              >
                Aceptar
              </v-btn>
            </v-time-picker>
          </v-menu>
          <v-menu
            ref="menuTo"
            v-model="menuTo"
            offset-y
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="items.timeTo"
                name="to"
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                :rules="items.to.rules"
                :label="items.to.label"
                required
                class="ml-2"
                style="width: 50%"
              ></v-text-field>
            </template>
            <v-time-picker
              v-model="items.timeTo"
              class="mt-4"
              scrollable
              format="24hr"
              :min="minTo"
              :max="maxTo"
              @click="$refs.menuTo.save(items.timeTo)"
            >
              <v-btn
                text
                color="primary"
                @click="menuTo = false"
                class="v-picker__actions"
              >
                Aceptar
              </v-btn>
            </v-time-picker>
          </v-menu>
        </div>
        <div class="d-flex mt-n5">
          <v-checkbox
            name="holidays"
            :label="items.holidays.label"
            v-model="items.holidays.data"
            style="width: 50%"
          />

          <v-checkbox
            name="noHolidays"
            :label="items.noHolidays.label"
            v-model="items.noHolidays.data"
            style="width: 50%"
          />
        </div>
        <v-autocomplete
          name="dfis"
          :items="items.dfis.items"
          :item-text="items.dfis.itemsText"
          :item-value="items.dfis.itemsValue"
          v-model="items.dfis.data"
          :label="items.dfis.label"
          outlined
          dense
          multiple
        />
        <v-select
          name="requiredPin"
          :items="items.requiredPin.items"
          :item-text="items.requiredPin.itemsText"
          :item-value="items.requiredPin.itemsValue"
          v-model="items.requiredPin.data"
          :label="items.requiredPin.label"
          outlined
          dense
        />
        <v-select
          name="requiredCacheo"
          :items="items.requiredCacheo.items"
          :item-text="items.requiredCacheo.itemsText"
          :item-value="items.requiredCacheo.itemsValue"
          v-model="items.requiredCacheo.data"
          :label="items.requiredCacheo.label"
          outlined
          dense
        />
        <v-text-field
          name="porcentage"
          v-model="items.porcentage.data"
          :type="items.porcentage.type"
          max="100"
          :disabled="items.requiredCacheo.data !== 1"
          :label="items.porcentage.label"
          :rules="items.porcentage.rules"
          outlined
          dense
          suffix="%"
        />
        <v-select
          name="requiredPassBack"
          :items="items.requiredPassBack.items"
          :item-text="items.requiredPassBack.itemsText"
          :item-value="items.requiredPassBack.itemsValue"
          v-model="items.requiredPassBack.data"
          :label="items.requiredPassBack.label"
          outlined
          dense
        />

        <div class="d-flex justify-space-between py-4">
          <v-btn class="bt-exit" @click="cancel">{{
            $tc("editRegistrations.cancel")
          }}</v-btn>
          <v-btn type="submit" class="bt-acept">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from "moment";
import schedules from "@/store/permisosDeAcceso/accessPermissions";
import Vue from "vue";

export default {
  props: {
    mode: String,
    itemsElement: Object,
  },

  data() {
    return {
      items: {},
      valid: true,
      error: false,
      alertValidate: "",
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      menuFrom: false,
      menuTo: false,
      maxFrom: "23:59",
      minFrom: "00:00",
      maxTo: "23:59",
      minTo: "00:00",
      disabledDayTo: false,
      disabledDayFrom: false,
    };
  },

  mounted() {
    this.items = Vue.observable(this.itemsElement);
  },
  watch: {
    itemsElement: {
      immediate: true,
      handler(value) {
        this.items = value;
      },
    },
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      this.handleSubmit(e.target);
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.itemsParse(itemsComplete);
    },
    cancel() {
      this.disabledDayFrom = false;
      this.disabledDayTo = false;
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        if (form.from > form.to && form.dayFrom == form.dayTo) {
          this.error = true;
          this.alertValidate = this.$tc("schedules.errorhs");
          this.alertError();
        } else {
          this.$emit("save", form);
          setTimeout(() => {
            this.cancel();
          }, 500);
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        this.alertError();
      }
    },
    itemsParse(form) {
      let noHolidays = form.noHolidays == "" ? true : false;
      let holidays = form.holidays == "" ? true : false;
      const fromValue = this.convertToMinutes(form.from, form.dayFrom);
      const toValue = this.convertToMinutes(form.to, form.dayTo);
      let requiredPin =
        form.requiredPin == "[object Object]"
          ? 2
          : parseInt(form.requiredPin, 10);
      let requiredPassBack =
        form.requiredPassBack == "[object Object]"
          ? 2
          : parseInt(form.requiredPassBack, 10);
      let requiredCacheo =
        form.requiredCacheo == "[object Object]"
          ? 2
          : parseInt(form.requiredCacheo, 10);
      let dfis =
        form.dfis === "[object Object]" || form.dfis === ""
          ? undefined
          : form.dfis.split(",").map((id) => parseInt(id, 10));
      let payload = {
        reqPin: requiredPin,
        reqPassBack: requiredPassBack,
        reqCacheo: requiredCacheo,
        nombre: form.element,
        desde: fromValue,
        hasta: toValue,
        porcenCacheo: parseInt(form.porcentage, 10),
        aplNoFeriados: noHolidays,
        aplFeriados: holidays,
        segmId: schedules.state.segmentId,
        permisoId: schedules.state.permissionId,
        dfis: dfis,
      };

      this.validation(payload);
    },
    convertToMinutes(value, dayValue) {
      const [hours, minutes] = value.split(":");
      const hoursInt = parseInt(hours, 10);
      const minutesInt = parseInt(minutes, 10);
      let totalMinutes = hoursInt * 60 + minutesInt;
      if (dayValue === "0") {
        totalMinutes -= 1440;
      } else if (dayValue === "2") {
        totalMinutes += 1440;
      }
      return totalMinutes;
    },
    timerChangeDate(input) {
      let data = input.data;

      if (data === "") {
        data = "00:10";
      } else if (!/^[0-9:]+$/.test(data)) {
        data = "00:00";
      } else {
        data = data.replace(/[^\d:]/g, "");
        if (data.length >= 2 && data.indexOf(":") === -1) {
          data = data.substring(0, 2) + ":" + data.substring(2);
        }

        data = data.substring(0, 5);
        const [horas, minutos] = data.split(":").map(Number);

        if (!isNaN(minutos) && minutos > 59) {
          data = `${horas}:59`;
        }
        if (!isNaN(horas) && horas > 12) {
          data = "12:00";
        } else if (horas === 12 && minutos > 0) {
          data = "12:00";
        }
      }
      input.data = data;
    },

    alertError() {
      setTimeout(() => {
        this.error = false;
      }, 2500);
    },
    changeTo(event) {
      this.items.timeTo = null;
      if (event == 2) {
        this.maxTo = "11:59";
        this.minTo = "00:00";
      }
    },
    changeFrom(event) {
      this.items.timeFrom = null;
      switch (event) {
        case 0:
          this.maxFrom = "23:59";
          this.minFrom = "12:00";
          this.disabledDayTo = true;
          this.items.dayTo.data = 1;
          this.items.timeTo = null;

          break;
        case 1:
          this.disabledDayTo = false;
          this.maxFrom = "23:59";
          this.minFrom = "00:00";
          this.items.timeTo = null;
          break;
        case 2:
          this.disabledDayTo = true;
          this.items.dayTo.data = 2;
          this.maxFrom = "11:59";
          this.minFrom = "00:00";
          this.items.timeTo = null;

          break;
        default:
          break;
      }
    },
    timeFromSave(time) {
      this.menuFrom = false;
      const momentTime = moment(time, "HH:mm");
      const duration = moment.duration(12, "hours");
      const newTime = momentTime.add(duration).format("HH:mm");
      switch (this.items.dayFrom.data) {
        case 0:
          this.minTo = "00:00";
          this.maxTo = newTime;
          break;

        case 2:
          this.minTo = time;
          this.maxTo = newTime;
          break;
      }
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.small {
  font-size: x-large;
}
</style>
